module.exports = __webpack_public_path__ + "static/img/half-circle-1.d5ab6025.svg";